/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConsumeMaterialDto,
  ConsumptionListResponse,
  ConsumptionPlanResponse,
  ConsumptionResultResponse,
  CreatePurchaseInvoiceDto,
  CreateStockTransferDto,
  InventoryAlertsListParams,
  InventoryAlertsResponse,
  InventoryListConsumptionParams,
  InventoryMaterialStockParams,
  InventoryMovementsParams,
  InventoryReconciliationReportParams,
  InventoryRemoveConsumption200,
  InventoryStockListParams,
  InventorySuggestParams,
  InventoryTransfersListParams,
  InventoryUsageParams,
  InventoryValuationParams,
  MaterialStockDetailResponse,
  MovementListResponse,
  PurchaseInvoiceListResponse,
  PurchaseInvoiceResponse,
  PurchaseInvoicesListParams,
  ReconciliationQueryDto,
  ReconciliationRepairResponse,
  ReconciliationReportResponse,
  SimpleAdjustDto,
  SimpleReceiveDto,
  StockListResponse,
  StockRowResponse,
  StockTransferListResponse,
  StockTransferResponse,
  SweepResultResponse,
  UsageReportResponse,
  ValuationResponse
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * availableMilli فقط بچ‌های فعال و منقضی‌نشده را می‌شمارد — همان چیزی که امروز قابل تزریق است. blockedMilli موجودی قرنطینه یا منقضی است که هنوز خالی نشده. ترتیب بر اساس فوریت است: بی‌موجودی، سپس کم‌موجود، سپس کمترین «روزهای کفایت». stockValueRials و averageUnitCostRials فقط با inventory.view_costs در پاسخ هستند.
 * @summary موجودی فعلی به تفکیک کالا
 */
export const inventoryStockList = (
    params?: InventoryStockListParams,
 signal?: AbortSignal
) => {


      return apiClient<StockListResponse>(
      {url: `/api/v1/inventory/stock`, method: 'GET',
        params, signal
    },
      );
    }




export const getInventoryStockListQueryKey = (params?: InventoryStockListParams,) => {
    return [
    `/api/v1/inventory/stock`, ...(params ? [params] : [])
    ] as const;
    }


export const getInventoryStockListQueryOptions = <TData = Awaited<ReturnType<typeof inventoryStockList>>, TError = void>(params?: InventoryStockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryStockList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInventoryStockListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inventoryStockList>>> = ({ signal }) => inventoryStockList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inventoryStockList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InventoryStockListQueryResult = NonNullable<Awaited<ReturnType<typeof inventoryStockList>>>
export type InventoryStockListQueryError = void


export function useInventoryStockList<TData = Awaited<ReturnType<typeof inventoryStockList>>, TError = void>(
 params: undefined |  InventoryStockListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryStockList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryStockList>>,
          TError,
          Awaited<ReturnType<typeof inventoryStockList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryStockList<TData = Awaited<ReturnType<typeof inventoryStockList>>, TError = void>(
 params?: InventoryStockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryStockList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryStockList>>,
          TError,
          Awaited<ReturnType<typeof inventoryStockList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryStockList<TData = Awaited<ReturnType<typeof inventoryStockList>>, TError = void>(
 params?: InventoryStockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryStockList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary موجودی فعلی به تفکیک کالا
 */

export function useInventoryStockList<TData = Awaited<ReturnType<typeof inventoryStockList>>, TError = void>(
 params?: InventoryStockListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryStockList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInventoryStockListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * بچ‌ها به ترتیب FEFO برمی‌گردند؛ نزدیک‌ترین انقضا اول.
 * @summary موجودی یک کالا به همراه جزئیات هر بچ
 */
export const inventoryMaterialStock = (
    materialId: string,
    params?: InventoryMaterialStockParams,
 signal?: AbortSignal
) => {


      return apiClient<MaterialStockDetailResponse>(
      {url: `/api/v1/inventory/stock/${materialId}`, method: 'GET',
        params, signal
    },
      );
    }




export const getInventoryMaterialStockQueryKey = (materialId: string,
    params?: InventoryMaterialStockParams,) => {
    return [
    `/api/v1/inventory/stock/${materialId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getInventoryMaterialStockQueryOptions = <TData = Awaited<ReturnType<typeof inventoryMaterialStock>>, TError = void>(materialId: string,
    params?: InventoryMaterialStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryMaterialStock>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInventoryMaterialStockQueryKey(materialId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inventoryMaterialStock>>> = ({ signal }) => inventoryMaterialStock(materialId,params, signal);





   return  { queryKey, queryFn, enabled: materialId !== null && materialId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inventoryMaterialStock>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InventoryMaterialStockQueryResult = NonNullable<Awaited<ReturnType<typeof inventoryMaterialStock>>>
export type InventoryMaterialStockQueryError = void


export function useInventoryMaterialStock<TData = Awaited<ReturnType<typeof inventoryMaterialStock>>, TError = void>(
 materialId: string,
    params: undefined |  InventoryMaterialStockParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryMaterialStock>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryMaterialStock>>,
          TError,
          Awaited<ReturnType<typeof inventoryMaterialStock>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryMaterialStock<TData = Awaited<ReturnType<typeof inventoryMaterialStock>>, TError = void>(
 materialId: string,
    params?: InventoryMaterialStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryMaterialStock>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryMaterialStock>>,
          TError,
          Awaited<ReturnType<typeof inventoryMaterialStock>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryMaterialStock<TData = Awaited<ReturnType<typeof inventoryMaterialStock>>, TError = void>(
 materialId: string,
    params?: InventoryMaterialStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryMaterialStock>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary موجودی یک کالا به همراه جزئیات هر بچ
 */

export function useInventoryMaterialStock<TData = Awaited<ReturnType<typeof inventoryMaterialStock>>, TError = void>(
 materialId: string,
    params?: InventoryMaterialStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryMaterialStock>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInventoryMaterialStockQueryOptions(materialId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * برای همهٔ پلن‌ها. مقدار را یا با packageCount یا با quantityReceivedMilli بفرستید، و مبلغ را یا با pricePerPackageRials یا با purchasePriceRials — نه هر دو. کالا به «موجودی بدون سری ساخت» همان شعبه اضافه می‌شود: یک گردش PURCHASE، بهای هر واحد به میانگین وزنی، و یک هزینهٔ «خرید مواد» در همان شعبه ثبت می‌شود — دقیقاً مثل ورود یک سری. پاسخ، ردیف موجودی همین کالا در همین شعبه است.
 * @summary ثبت ورود کالا بدون سری ساخت (موجودی ساده)
 */
export const inventorySimpleReceive = (
    materialId: string,
    simpleReceiveDto: SimpleReceiveDto,
 signal?: AbortSignal
) => {


      return apiClient<StockRowResponse>(
      {url: `/api/v1/inventory/stock/${materialId}/receive`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: simpleReceiveDto, signal
    },
      );
    }




export const getInventorySimpleReceiveMutationKey = () => ['inventorySimpleReceive'] as const;

export const getInventorySimpleReceiveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventorySimpleReceive>>, TError,InventorySimpleReceiveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventorySimpleReceive>>, TError,InventorySimpleReceiveMutationVariables, TContext> => {

const mutationKey = getInventorySimpleReceiveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventorySimpleReceive>>, InventorySimpleReceiveMutationVariables> = (props) => {
          const {materialId,data} = props ?? {};

          return  inventorySimpleReceive(materialId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventorySimpleReceiveMutationResult = NonNullable<Awaited<ReturnType<typeof inventorySimpleReceive>>>
    export type InventorySimpleReceiveMutationBody = SimpleReceiveDto
    export type InventorySimpleReceiveMutationError = void
    export type InventorySimpleReceiveMutationVariables = {materialId: string;data: SimpleReceiveDto}

    /**
 * @summary ثبت ورود کالا بدون سری ساخت (موجودی ساده)
 */
export const useInventorySimpleReceive = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventorySimpleReceive>>, TError,InventorySimpleReceiveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventorySimpleReceive>>,
        TError,
        InventorySimpleReceiveMutationVariables,
        TContext
      > => {
      return useMutation(getInventorySimpleReceiveMutationOptions(options), queryClient);
    }
    /**
 * برای همهٔ پلن‌ها. mode=COUNT با countedMilli یعنی «این‌قدر شمردیم» و سرور فقط اختلاف را ثبت می‌کند؛ mode=DELTA با deltaMilli یعنی تغییر با علامت. کاهش از سری‌های قابل مصرف همین شعبه به ترتیب نزدیک‌ترین انقضا برداشته می‌شود؛ افزایش به «موجودی بدون سری ساخت» اضافه می‌شود. kind=WASTAGE فقط کم می‌کند. دلیل اجباری است.
 * @summary شمارش یا اصلاح موجودی بدون سری ساخت (موجودی ساده)
 */
export const inventorySimpleAdjust = (
    materialId: string,
    simpleAdjustDto: SimpleAdjustDto,
 signal?: AbortSignal
) => {


      return apiClient<StockRowResponse>(
      {url: `/api/v1/inventory/stock/${materialId}/adjust`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: simpleAdjustDto, signal
    },
      );
    }




export const getInventorySimpleAdjustMutationKey = () => ['inventorySimpleAdjust'] as const;

export const getInventorySimpleAdjustMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventorySimpleAdjust>>, TError,InventorySimpleAdjustMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventorySimpleAdjust>>, TError,InventorySimpleAdjustMutationVariables, TContext> => {

const mutationKey = getInventorySimpleAdjustMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventorySimpleAdjust>>, InventorySimpleAdjustMutationVariables> = (props) => {
          const {materialId,data} = props ?? {};

          return  inventorySimpleAdjust(materialId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventorySimpleAdjustMutationResult = NonNullable<Awaited<ReturnType<typeof inventorySimpleAdjust>>>
    export type InventorySimpleAdjustMutationBody = SimpleAdjustDto
    export type InventorySimpleAdjustMutationError = void
    export type InventorySimpleAdjustMutationVariables = {materialId: string;data: SimpleAdjustDto}

    /**
 * @summary شمارش یا اصلاح موجودی بدون سری ساخت (موجودی ساده)
 */
export const useInventorySimpleAdjust = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventorySimpleAdjust>>, TError,InventorySimpleAdjustMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventorySimpleAdjust>>,
        TError,
        InventorySimpleAdjustMutationVariables,
        TContext
      > => {
      return useMutation(getInventorySimpleAdjustMutationOptions(options), queryClient);
    }
    /**
 * کل پاسخ مبلغ است، پس این مسیر با نبود دسترسی ۴۰۳ می‌دهد نه پاسخ خالی. totalValueRials فقط موجودی قابل مصرف است و blockedValueRials موجودی قرنطینه و منقضی.
 * @summary ارزش‌گذاری انبار به بهای خرید
 */
export const inventoryValuation = (
    params?: InventoryValuationParams,
 signal?: AbortSignal
) => {


      return apiClient<ValuationResponse>(
      {url: `/api/v1/inventory/valuation`, method: 'GET',
        params, signal
    },
      );
    }




export const getInventoryValuationQueryKey = (params?: InventoryValuationParams,) => {
    return [
    `/api/v1/inventory/valuation`, ...(params ? [params] : [])
    ] as const;
    }


export const getInventoryValuationQueryOptions = <TData = Awaited<ReturnType<typeof inventoryValuation>>, TError = void>(params?: InventoryValuationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryValuation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInventoryValuationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inventoryValuation>>> = ({ signal }) => inventoryValuation(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inventoryValuation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InventoryValuationQueryResult = NonNullable<Awaited<ReturnType<typeof inventoryValuation>>>
export type InventoryValuationQueryError = void


export function useInventoryValuation<TData = Awaited<ReturnType<typeof inventoryValuation>>, TError = void>(
 params: undefined |  InventoryValuationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryValuation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryValuation>>,
          TError,
          Awaited<ReturnType<typeof inventoryValuation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryValuation<TData = Awaited<ReturnType<typeof inventoryValuation>>, TError = void>(
 params?: InventoryValuationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryValuation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryValuation>>,
          TError,
          Awaited<ReturnType<typeof inventoryValuation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryValuation<TData = Awaited<ReturnType<typeof inventoryValuation>>, TError = void>(
 params?: InventoryValuationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryValuation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ارزش‌گذاری انبار به بهای خرید
 */

export function useInventoryValuation<TData = Awaited<ReturnType<typeof inventoryValuation>>, TError = void>(
 params?: InventoryValuationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryValuation>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInventoryValuationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * از دفتر گردش انبار خوانده می‌شود نه از مصرف جلسه، تا دورریز به‌دلیل انقضا هم در نرخ دیده شود؛ گزارشی که فقط مصرف را ببیند، کلینیکی را که یک‌سوم بوتاکسش را دور می‌ریزد سالم نشان می‌دهد.
 * @summary نرخ مصرف، نرخ ضایعات و روزهای کفایت
 */
export const inventoryUsage = (
    params?: InventoryUsageParams,
 signal?: AbortSignal
) => {


      return apiClient<UsageReportResponse>(
      {url: `/api/v1/inventory/usage`, method: 'GET',
        params, signal
    },
      );
    }




export const getInventoryUsageQueryKey = (params?: InventoryUsageParams,) => {
    return [
    `/api/v1/inventory/usage`, ...(params ? [params] : [])
    ] as const;
    }


export const getInventoryUsageQueryOptions = <TData = Awaited<ReturnType<typeof inventoryUsage>>, TError = void>(params?: InventoryUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryUsage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInventoryUsageQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inventoryUsage>>> = ({ signal }) => inventoryUsage(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inventoryUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InventoryUsageQueryResult = NonNullable<Awaited<ReturnType<typeof inventoryUsage>>>
export type InventoryUsageQueryError = void


export function useInventoryUsage<TData = Awaited<ReturnType<typeof inventoryUsage>>, TError = void>(
 params: undefined |  InventoryUsageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryUsage>>,
          TError,
          Awaited<ReturnType<typeof inventoryUsage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryUsage<TData = Awaited<ReturnType<typeof inventoryUsage>>, TError = void>(
 params?: InventoryUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryUsage>>,
          TError,
          Awaited<ReturnType<typeof inventoryUsage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryUsage<TData = Awaited<ReturnType<typeof inventoryUsage>>, TError = void>(
 params?: InventoryUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryUsage>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary نرخ مصرف، نرخ ضایعات و روزهای کفایت
 */

export function useInventoryUsage<TData = Awaited<ReturnType<typeof inventoryUsage>>, TError = void>(
 params?: InventoryUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryUsage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInventoryUsageQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * هر تغییر موجودی — خرید، مصرف، ضایعات، اصلاح، برگشت و دورریز به‌دلیل انقضا — دقیقاً یک ردیف اینجا دارد. این جدول فقط افزودنی است: هیچ مسیری در برنامه آن را ویرایش یا حذف نمی‌کند.
 * @summary دفتر گردش انبار
 */
export const inventoryMovements = (
    params?: InventoryMovementsParams,
 signal?: AbortSignal
) => {


      return apiClient<MovementListResponse>(
      {url: `/api/v1/inventory/movements`, method: 'GET',
        params, signal
    },
      );
    }




export const getInventoryMovementsQueryKey = (params?: InventoryMovementsParams,) => {
    return [
    `/api/v1/inventory/movements`, ...(params ? [params] : [])
    ] as const;
    }


export const getInventoryMovementsQueryOptions = <TData = Awaited<ReturnType<typeof inventoryMovements>>, TError = void>(params?: InventoryMovementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryMovements>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInventoryMovementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inventoryMovements>>> = ({ signal }) => inventoryMovements(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inventoryMovements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InventoryMovementsQueryResult = NonNullable<Awaited<ReturnType<typeof inventoryMovements>>>
export type InventoryMovementsQueryError = void


export function useInventoryMovements<TData = Awaited<ReturnType<typeof inventoryMovements>>, TError = void>(
 params: undefined |  InventoryMovementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryMovements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryMovements>>,
          TError,
          Awaited<ReturnType<typeof inventoryMovements>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryMovements<TData = Awaited<ReturnType<typeof inventoryMovements>>, TError = void>(
 params?: InventoryMovementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryMovements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryMovements>>,
          TError,
          Awaited<ReturnType<typeof inventoryMovements>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryMovements<TData = Awaited<ReturnType<typeof inventoryMovements>>, TError = void>(
 params?: InventoryMovementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryMovements>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary دفتر گردش انبار
 */

export function useInventoryMovements<TData = Awaited<ReturnType<typeof inventoryMovements>>, TError = void>(
 params?: InventoryMovementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryMovements>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInventoryMovementsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * نزدیک‌ترین بچ به انقضا که تمام مقدار درخواستی را داشته باشد. اگر هیچ بچی به‌تنهایی کافی نباشد، suggestedLotId خالی می‌ماند و allocations نشان می‌دهد مصرف بین کدام بچ‌ها تقسیم می‌شود. این همان نقشه‌ای است که هنگام ثبت اجرا می‌شود — پیش‌نمایش و ثبت یک تابع مشترک دارند.
 * @summary پیشنهاد بچ برای مصرف (FEFO)
 */
export const inventorySuggest = (
    params: InventorySuggestParams,
 signal?: AbortSignal
) => {


      return apiClient<ConsumptionPlanResponse>(
      {url: `/api/v1/inventory/consumption/suggest`, method: 'GET',
        params, signal
    },
      );
    }




export const getInventorySuggestQueryKey = (params?: InventorySuggestParams,) => {
    return [
    `/api/v1/inventory/consumption/suggest`, ...(params ? [params] : [])
    ] as const;
    }


export const getInventorySuggestQueryOptions = <TData = Awaited<ReturnType<typeof inventorySuggest>>, TError = void>(params: InventorySuggestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventorySuggest>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInventorySuggestQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inventorySuggest>>> = ({ signal }) => inventorySuggest(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inventorySuggest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InventorySuggestQueryResult = NonNullable<Awaited<ReturnType<typeof inventorySuggest>>>
export type InventorySuggestQueryError = void


export function useInventorySuggest<TData = Awaited<ReturnType<typeof inventorySuggest>>, TError = void>(
 params: InventorySuggestParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventorySuggest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventorySuggest>>,
          TError,
          Awaited<ReturnType<typeof inventorySuggest>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventorySuggest<TData = Awaited<ReturnType<typeof inventorySuggest>>, TError = void>(
 params: InventorySuggestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventorySuggest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventorySuggest>>,
          TError,
          Awaited<ReturnType<typeof inventorySuggest>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventorySuggest<TData = Awaited<ReturnType<typeof inventorySuggest>>, TError = void>(
 params: InventorySuggestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventorySuggest>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary پیشنهاد بچ برای مصرف (FEFO)
 */

export function useInventorySuggest<TData = Awaited<ReturnType<typeof inventorySuggest>>, TError = void>(
 params: InventorySuggestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventorySuggest>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInventorySuggestQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * پزشکی که دسترسی session.view_all ندارد فقط مصرف جلسات خودش را می‌بیند. costRials فقط با inventory.view_costs برمی‌گردد.
 * @summary تاریخچهٔ مصرف
 */
export const inventoryListConsumption = (
    params?: InventoryListConsumptionParams,
 signal?: AbortSignal
) => {


      return apiClient<ConsumptionListResponse>(
      {url: `/api/v1/inventory/consumption`, method: 'GET',
        params, signal
    },
      );
    }




export const getInventoryListConsumptionQueryKey = (params?: InventoryListConsumptionParams,) => {
    return [
    `/api/v1/inventory/consumption`, ...(params ? [params] : [])
    ] as const;
    }


export const getInventoryListConsumptionQueryOptions = <TData = Awaited<ReturnType<typeof inventoryListConsumption>>, TError = void>(params?: InventoryListConsumptionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryListConsumption>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInventoryListConsumptionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inventoryListConsumption>>> = ({ signal }) => inventoryListConsumption(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inventoryListConsumption>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InventoryListConsumptionQueryResult = NonNullable<Awaited<ReturnType<typeof inventoryListConsumption>>>
export type InventoryListConsumptionQueryError = void


export function useInventoryListConsumption<TData = Awaited<ReturnType<typeof inventoryListConsumption>>, TError = void>(
 params: undefined |  InventoryListConsumptionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryListConsumption>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryListConsumption>>,
          TError,
          Awaited<ReturnType<typeof inventoryListConsumption>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryListConsumption<TData = Awaited<ReturnType<typeof inventoryListConsumption>>, TError = void>(
 params?: InventoryListConsumptionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryListConsumption>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryListConsumption>>,
          TError,
          Awaited<ReturnType<typeof inventoryListConsumption>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryListConsumption<TData = Awaited<ReturnType<typeof inventoryListConsumption>>, TError = void>(
 params?: InventoryListConsumptionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryListConsumption>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary تاریخچهٔ مصرف
 */

export function useInventoryListConsumption<TData = Awaited<ReturnType<typeof inventoryListConsumption>>, TError = void>(
 params?: InventoryListConsumptionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryListConsumption>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInventoryListConsumptionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * بهای هر واحد در همین لحظه از بچ عکس‌برداری و روی ردیف مصرف ثبت می‌شود، پس گرانی ماه بعد حاشیهٔ سود جلسات گذشته را تغییر نمی‌دهد. اگر بچ انتخابی با پیشنهاد FEFO فرق داشته باشد، overrideReason اجباری است و انتخاب در fefoSuggestedLotId ثبت می‌ماند. discardOpenedRemainder=true باقی‌ماندهٔ هر بچی را که این برداشت باز کرده ضایعات ثبت می‌کند (برای ویال تک‌مصرف درست است، برای سرنگ فیلر نه). همهٔ ردیف‌ها در یک تراکنش ثبت می‌شوند.
 * @summary ثبت مصرف یک کالا در یک جلسه
 */
export const inventoryConsume = (
    consumeMaterialDto: ConsumeMaterialDto,
 signal?: AbortSignal
) => {


      return apiClient<ConsumptionResultResponse>(
      {url: `/api/v1/inventory/consumption`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: consumeMaterialDto, signal
    },
      );
    }




export const getInventoryConsumeMutationKey = () => ['inventoryConsume'] as const;

export const getInventoryConsumeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryConsume>>, TError,InventoryConsumeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryConsume>>, TError,InventoryConsumeMutationVariables, TContext> => {

const mutationKey = getInventoryConsumeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryConsume>>, InventoryConsumeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  inventoryConsume(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventoryConsumeMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryConsume>>>
    export type InventoryConsumeMutationBody = ConsumeMaterialDto
    export type InventoryConsumeMutationError = void
    export type InventoryConsumeMutationVariables = {data: ConsumeMaterialDto}

    /**
 * @summary ثبت مصرف یک کالا در یک جلسه
 */
export const useInventoryConsume = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryConsume>>, TError,InventoryConsumeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryConsume>>,
        TError,
        InventoryConsumeMutationVariables,
        TContext
      > => {
      return useMutation(getInventoryConsumeMutationOptions(options), queryClient);
    }
    /**
 * یک گردش RETURN جبرانی ثبت می‌شود و ردیف مصرف حذف می‌گردد. دفتر گردش هر دو رویداد را نگه می‌دارد، چون فقط افزودنی است؛ ردیف مصرف حذف می‌شود چون بهای تمام‌شده از همان ردیف‌ها جمع زده می‌شود و اصلاحی که هزینه را جا بگذارد اصلاح نیست.
 * @summary حذف یک ردیف مصرف و بازگرداندن موجودی
 */
export const inventoryRemoveConsumption = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<InventoryRemoveConsumption200>(
      {url: `/api/v1/inventory/consumption/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getInventoryRemoveConsumptionMutationKey = () => ['inventoryRemoveConsumption'] as const;

export const getInventoryRemoveConsumptionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryRemoveConsumption>>, TError,InventoryRemoveConsumptionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryRemoveConsumption>>, TError,InventoryRemoveConsumptionMutationVariables, TContext> => {

const mutationKey = getInventoryRemoveConsumptionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryRemoveConsumption>>, InventoryRemoveConsumptionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  inventoryRemoveConsumption(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventoryRemoveConsumptionMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryRemoveConsumption>>>

    export type InventoryRemoveConsumptionMutationError = void
    export type InventoryRemoveConsumptionMutationVariables = {id: string}

    /**
 * @summary حذف یک ردیف مصرف و بازگرداندن موجودی
 */
export const useInventoryRemoveConsumption = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryRemoveConsumption>>, TError,InventoryRemoveConsumptionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryRemoveConsumption>>,
        TError,
        InventoryRemoveConsumptionMutationVariables,
        TContext
      > => {
      return useMutation(getInventoryRemoveConsumptionMutationOptions(options), queryClient);
    }
    /**
 * زنده محاسبه می‌شود، نه از روی اعلان‌های ثبت‌شده: کلینیکی که هشدار هفتهٔ پیش را بسته است هنوز باید وضعیت امروز را درست ببیند. valueAtRiskRials فقط با inventory.view_costs می‌آید.
 * @summary هشدارهای کمبود موجودی و نزدیکی انقضا
 */
export const inventoryAlertsList = (
    params?: InventoryAlertsListParams,
 signal?: AbortSignal
) => {


      return apiClient<InventoryAlertsResponse>(
      {url: `/api/v1/inventory/alerts`, method: 'GET',
        params, signal
    },
      );
    }




export const getInventoryAlertsListQueryKey = (params?: InventoryAlertsListParams,) => {
    return [
    `/api/v1/inventory/alerts`, ...(params ? [params] : [])
    ] as const;
    }


export const getInventoryAlertsListQueryOptions = <TData = Awaited<ReturnType<typeof inventoryAlertsList>>, TError = void>(params?: InventoryAlertsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryAlertsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInventoryAlertsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inventoryAlertsList>>> = ({ signal }) => inventoryAlertsList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inventoryAlertsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InventoryAlertsListQueryResult = NonNullable<Awaited<ReturnType<typeof inventoryAlertsList>>>
export type InventoryAlertsListQueryError = void


export function useInventoryAlertsList<TData = Awaited<ReturnType<typeof inventoryAlertsList>>, TError = void>(
 params: undefined |  InventoryAlertsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryAlertsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryAlertsList>>,
          TError,
          Awaited<ReturnType<typeof inventoryAlertsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryAlertsList<TData = Awaited<ReturnType<typeof inventoryAlertsList>>, TError = void>(
 params?: InventoryAlertsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryAlertsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryAlertsList>>,
          TError,
          Awaited<ReturnType<typeof inventoryAlertsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryAlertsList<TData = Awaited<ReturnType<typeof inventoryAlertsList>>, TError = void>(
 params?: InventoryAlertsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryAlertsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary هشدارهای کمبود موجودی و نزدیکی انقضا
 */

export function useInventoryAlertsList<TData = Awaited<ReturnType<typeof inventoryAlertsList>>, TError = void>(
 params?: InventoryAlertsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryAlertsList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInventoryAlertsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * همان کاری که کار شبانه می‌کند: بچ‌های تاریخ‌گذشته را با گردش EXPIRY_WRITE_OFF از موجودی خارج می‌کند و اعلان‌های کمبود و انقضا را می‌سازد. بی‌خطر است اگر چند بار اجرا شود.
 * @summary اجرای دستی جاروی انبار برای همین کلینیک
 */
export const inventorySweep = (

 signal?: AbortSignal
) => {


      return apiClient<SweepResultResponse>(
      {url: `/api/v1/inventory/alerts/sweep`, method: 'POST', signal
    },
      );
    }




export const getInventorySweepMutationKey = () => ['inventorySweep'] as const;

export const getInventorySweepMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventorySweep>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventorySweep>>, TError,void, TContext> => {

const mutationKey = getInventorySweepMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventorySweep>>, void> = () => {


          return  inventorySweep()
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventorySweepMutationResult = NonNullable<Awaited<ReturnType<typeof inventorySweep>>>

    export type InventorySweepMutationError = void


    /**
 * @summary اجرای دستی جاروی انبار برای همین کلینیک
 */
export const useInventorySweep = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventorySweep>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventorySweep>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getInventorySweepMutationOptions(options), queryClient);
    }
    /**
 * برای هر بچ، «موجودی ثبت‌شده» با «مجموع همهٔ گردش‌ها» مقایسه می‌شود. این دو باید همیشه برابر باشند — ستون موجودی فقط یک کش است و دفتر گردش حقیقت. اختلاف یعنی جایی خارج از مسیر عادی به موجودی دست زده شده؛ نتیجه‌اش این است که پزشک ساعت ۱۹:۴۰ نمی‌تواند تزریق کند.
 * @summary مغایرت‌گیری موجودی با دفتر گردش
 */
export const inventoryReconciliationReport = (
    params?: InventoryReconciliationReportParams,
 signal?: AbortSignal
) => {


      return apiClient<ReconciliationReportResponse>(
      {url: `/api/v1/inventory/reconciliation`, method: 'GET',
        params, signal
    },
      );
    }




export const getInventoryReconciliationReportQueryKey = (params?: InventoryReconciliationReportParams,) => {
    return [
    `/api/v1/inventory/reconciliation`, ...(params ? [params] : [])
    ] as const;
    }


export const getInventoryReconciliationReportQueryOptions = <TData = Awaited<ReturnType<typeof inventoryReconciliationReport>>, TError = void>(params?: InventoryReconciliationReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryReconciliationReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInventoryReconciliationReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inventoryReconciliationReport>>> = ({ signal }) => inventoryReconciliationReport(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inventoryReconciliationReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InventoryReconciliationReportQueryResult = NonNullable<Awaited<ReturnType<typeof inventoryReconciliationReport>>>
export type InventoryReconciliationReportQueryError = void


export function useInventoryReconciliationReport<TData = Awaited<ReturnType<typeof inventoryReconciliationReport>>, TError = void>(
 params: undefined |  InventoryReconciliationReportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryReconciliationReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryReconciliationReport>>,
          TError,
          Awaited<ReturnType<typeof inventoryReconciliationReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryReconciliationReport<TData = Awaited<ReturnType<typeof inventoryReconciliationReport>>, TError = void>(
 params?: InventoryReconciliationReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryReconciliationReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryReconciliationReport>>,
          TError,
          Awaited<ReturnType<typeof inventoryReconciliationReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryReconciliationReport<TData = Awaited<ReturnType<typeof inventoryReconciliationReport>>, TError = void>(
 params?: InventoryReconciliationReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryReconciliationReport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary مغایرت‌گیری موجودی با دفتر گردش
 */

export function useInventoryReconciliationReport<TData = Awaited<ReturnType<typeof inventoryReconciliationReport>>, TError = void>(
 params?: InventoryReconciliationReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryReconciliationReport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInventoryReconciliationReportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * ستون موجودی را برابر مجموع گردش‌ها می‌کند و هیچ سند گردشی نمی‌سازد، چون چیزی جابه‌جا نشده است: موجودی همیشه همان بوده که گردش‌ها می‌گویند. ساختن یک «اصلاح» ساختگی یعنی نوشتن رویدادی که رخ نداده در دفتری که فقط افزودنی است. عملیات در گزارش ممیزی ثبت می‌شود.
 * @summary اصلاح کش موجودی از روی دفتر گردش
 */
export const inventoryReconciliationRepair = (
    reconciliationQueryDto: ReconciliationQueryDto,
 signal?: AbortSignal
) => {


      return apiClient<ReconciliationRepairResponse>(
      {url: `/api/v1/inventory/reconciliation/repair`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reconciliationQueryDto, signal
    },
      );
    }




export const getInventoryReconciliationRepairMutationKey = () => ['inventoryReconciliationRepair'] as const;

export const getInventoryReconciliationRepairMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryReconciliationRepair>>, TError,InventoryReconciliationRepairMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryReconciliationRepair>>, TError,InventoryReconciliationRepairMutationVariables, TContext> => {

const mutationKey = getInventoryReconciliationRepairMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryReconciliationRepair>>, InventoryReconciliationRepairMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  inventoryReconciliationRepair(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventoryReconciliationRepairMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryReconciliationRepair>>>
    export type InventoryReconciliationRepairMutationBody = ReconciliationQueryDto
    export type InventoryReconciliationRepairMutationError = void
    export type InventoryReconciliationRepairMutationVariables = {data: ReconciliationQueryDto}

    /**
 * @summary اصلاح کش موجودی از روی دفتر گردش
 */
export const useInventoryReconciliationRepair = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryReconciliationRepair>>, TError,InventoryReconciliationRepairMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryReconciliationRepair>>,
        TError,
        InventoryReconciliationRepairMutationVariables,
        TContext
      > => {
      return useMutation(getInventoryReconciliationRepairMutationOptions(options), queryClient);
    }
    /**
 * بخشی از موجودی یک سری از شعبهٔ مبدأ به شعبهٔ مقصد می‌رود: یک گردش TRANSFER_OUT روی سری مبدأ و یک TRANSFER_IN روی همان سری در مقصد (اگر نبود، با همان شمارهٔ سری، تاریخ انقضا و تأمین‌کننده ساخته می‌شود)، هر دو با یک transferId و یک بهای واحد. موجودی ساده به «موجودی بدون سری ساخت» مقصد می‌رود. مقدار و مبلغ خرید سری‌ها تغییر نمی‌کند و هزینهٔ «خرید مواد» ثبت نمی‌شود؛ بهای هر واحد مقصد میانگین وزنی موجودی خودش و آنچه رسیده می‌شود.
 * @summary انتقال موجودی بین شعبه‌ها
 */
export const inventoryTransfersCreate = (
    createStockTransferDto: CreateStockTransferDto,
 signal?: AbortSignal
) => {


      return apiClient<StockTransferResponse>(
      {url: `/api/v1/inventory/transfers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createStockTransferDto, signal
    },
      );
    }




export const getInventoryTransfersCreateMutationKey = () => ['inventoryTransfersCreate'] as const;

export const getInventoryTransfersCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryTransfersCreate>>, TError,InventoryTransfersCreateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof inventoryTransfersCreate>>, TError,InventoryTransfersCreateMutationVariables, TContext> => {

const mutationKey = getInventoryTransfersCreateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inventoryTransfersCreate>>, InventoryTransfersCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  inventoryTransfersCreate(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InventoryTransfersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof inventoryTransfersCreate>>>
    export type InventoryTransfersCreateMutationBody = CreateStockTransferDto
    export type InventoryTransfersCreateMutationError = void
    export type InventoryTransfersCreateMutationVariables = {data: CreateStockTransferDto}

    /**
 * @summary انتقال موجودی بین شعبه‌ها
 */
export const useInventoryTransfersCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inventoryTransfersCreate>>, TError,InventoryTransfersCreateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inventoryTransfersCreate>>,
        TError,
        InventoryTransfersCreateMutationVariables,
        TContext
      > => {
      return useMutation(getInventoryTransfersCreateMutationOptions(options), queryClient);
    }
    /**
 * تازه‌ترین اول. کاربری که فقط به بعضی شعبه‌ها دسترسی دارد انتقال‌هایی را می‌بیند که یک سرِ آن‌ها در شعبه‌های اوست. unitCostRials و valueRials فقط با inventory.view_costs می‌آیند.
 * @summary فهرست انتقال‌های بین شعبه‌ها
 */
export const inventoryTransfersList = (
    params?: InventoryTransfersListParams,
 signal?: AbortSignal
) => {


      return apiClient<StockTransferListResponse>(
      {url: `/api/v1/inventory/transfers`, method: 'GET',
        params, signal
    },
      );
    }




export const getInventoryTransfersListQueryKey = (params?: InventoryTransfersListParams,) => {
    return [
    `/api/v1/inventory/transfers`, ...(params ? [params] : [])
    ] as const;
    }


export const getInventoryTransfersListQueryOptions = <TData = Awaited<ReturnType<typeof inventoryTransfersList>>, TError = void>(params?: InventoryTransfersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryTransfersList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInventoryTransfersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof inventoryTransfersList>>> = ({ signal }) => inventoryTransfersList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof inventoryTransfersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InventoryTransfersListQueryResult = NonNullable<Awaited<ReturnType<typeof inventoryTransfersList>>>
export type InventoryTransfersListQueryError = void


export function useInventoryTransfersList<TData = Awaited<ReturnType<typeof inventoryTransfersList>>, TError = void>(
 params: undefined |  InventoryTransfersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryTransfersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryTransfersList>>,
          TError,
          Awaited<ReturnType<typeof inventoryTransfersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryTransfersList<TData = Awaited<ReturnType<typeof inventoryTransfersList>>, TError = void>(
 params?: InventoryTransfersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryTransfersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof inventoryTransfersList>>,
          TError,
          Awaited<ReturnType<typeof inventoryTransfersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInventoryTransfersList<TData = Awaited<ReturnType<typeof inventoryTransfersList>>, TError = void>(
 params?: InventoryTransfersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryTransfersList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست انتقال‌های بین شعبه‌ها
 */

export function useInventoryTransfersList<TData = Awaited<ReturnType<typeof inventoryTransfersList>>, TError = void>(
 params?: InventoryTransfersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof inventoryTransfersList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInventoryTransfersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * یک فاکتور تأمین‌کننده با ۱ تا ۱۰۰ ردیف، در یک تراکنش: هر ردیف BATCH یک سری ساخت جدا و هر ردیف POOL موجودی ساده. تخفیف فاکتور به نسبت مبلغ ردیف‌ها و به ریال کامل روی قیمت خرید هر ردیف پخش می‌شود؛ یک هزینهٔ «خرید مواد» به جمع خالص ردیف‌ها و یک هزینهٔ «مالیات» به مبلغ ارزش افزوده ثبت می‌شود. یا همه ثبت می‌شود یا هیچ.
 * @summary ثبت فاکتور خرید
 */
export const purchaseInvoicesCreate = (
    createPurchaseInvoiceDto: CreatePurchaseInvoiceDto,
 signal?: AbortSignal
) => {


      return apiClient<PurchaseInvoiceResponse>(
      {url: `/api/v1/inventory/purchase-invoices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPurchaseInvoiceDto, signal
    },
      );
    }




export const getPurchaseInvoicesCreateMutationKey = () => ['purchaseInvoicesCreate'] as const;

export const getPurchaseInvoicesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchaseInvoicesCreate>>, TError,PurchaseInvoicesCreateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof purchaseInvoicesCreate>>, TError,PurchaseInvoicesCreateMutationVariables, TContext> => {

const mutationKey = getPurchaseInvoicesCreateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchaseInvoicesCreate>>, PurchaseInvoicesCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  purchaseInvoicesCreate(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PurchaseInvoicesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof purchaseInvoicesCreate>>>
    export type PurchaseInvoicesCreateMutationBody = CreatePurchaseInvoiceDto
    export type PurchaseInvoicesCreateMutationError = void
    export type PurchaseInvoicesCreateMutationVariables = {data: CreatePurchaseInvoiceDto}

    /**
 * @summary ثبت فاکتور خرید
 */
export const usePurchaseInvoicesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchaseInvoicesCreate>>, TError,PurchaseInvoicesCreateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof purchaseInvoicesCreate>>,
        TError,
        PurchaseInvoicesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getPurchaseInvoicesCreateMutationOptions(options), queryClient);
    }
    /**
 * تازه‌ترین تاریخ فاکتور اول؛ فقط شعبه‌هایی که کاربر به آن‌ها دسترسی دارد.
 * @summary فهرست فاکتورهای خرید
 */
export const purchaseInvoicesList = (
    params?: PurchaseInvoicesListParams,
 signal?: AbortSignal
) => {


      return apiClient<PurchaseInvoiceListResponse>(
      {url: `/api/v1/inventory/purchase-invoices`, method: 'GET',
        params, signal
    },
      );
    }




export const getPurchaseInvoicesListQueryKey = (params?: PurchaseInvoicesListParams,) => {
    return [
    `/api/v1/inventory/purchase-invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getPurchaseInvoicesListQueryOptions = <TData = Awaited<ReturnType<typeof purchaseInvoicesList>>, TError = void>(params?: PurchaseInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseInvoicesList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchaseInvoicesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseInvoicesList>>> = ({ signal }) => purchaseInvoicesList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseInvoicesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseInvoicesListQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseInvoicesList>>>
export type PurchaseInvoicesListQueryError = void


export function usePurchaseInvoicesList<TData = Awaited<ReturnType<typeof purchaseInvoicesList>>, TError = void>(
 params: undefined |  PurchaseInvoicesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseInvoicesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseInvoicesList>>,
          TError,
          Awaited<ReturnType<typeof purchaseInvoicesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseInvoicesList<TData = Awaited<ReturnType<typeof purchaseInvoicesList>>, TError = void>(
 params?: PurchaseInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseInvoicesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseInvoicesList>>,
          TError,
          Awaited<ReturnType<typeof purchaseInvoicesList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseInvoicesList<TData = Awaited<ReturnType<typeof purchaseInvoicesList>>, TError = void>(
 params?: PurchaseInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseInvoicesList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست فاکتورهای خرید
 */

export function usePurchaseInvoicesList<TData = Awaited<ReturnType<typeof purchaseInvoicesList>>, TError = void>(
 params?: PurchaseInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseInvoicesList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseInvoicesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary جزئیات یک فاکتور خرید، با ردیف‌ها
 */
export const purchaseInvoicesGetById = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<PurchaseInvoiceResponse>(
      {url: `/api/v1/inventory/purchase-invoices/${id}`, method: 'GET', signal
    },
      );
    }




export const getPurchaseInvoicesGetByIdQueryKey = (id: string,) => {
    return [
    `/api/v1/inventory/purchase-invoices/${id}`
    ] as const;
    }


export const getPurchaseInvoicesGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof purchaseInvoicesGetById>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseInvoicesGetById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchaseInvoicesGetByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseInvoicesGetById>>> = ({ signal }) => purchaseInvoicesGetById(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseInvoicesGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseInvoicesGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseInvoicesGetById>>>
export type PurchaseInvoicesGetByIdQueryError = void


export function usePurchaseInvoicesGetById<TData = Awaited<ReturnType<typeof purchaseInvoicesGetById>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseInvoicesGetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseInvoicesGetById>>,
          TError,
          Awaited<ReturnType<typeof purchaseInvoicesGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseInvoicesGetById<TData = Awaited<ReturnType<typeof purchaseInvoicesGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseInvoicesGetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseInvoicesGetById>>,
          TError,
          Awaited<ReturnType<typeof purchaseInvoicesGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseInvoicesGetById<TData = Awaited<ReturnType<typeof purchaseInvoicesGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseInvoicesGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary جزئیات یک فاکتور خرید، با ردیف‌ها
 */

export function usePurchaseInvoicesGetById<TData = Awaited<ReturnType<typeof purchaseInvoicesGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseInvoicesGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseInvoicesGetByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






